import React from 'react';

const ImgArtists = ({ artists }) => {
  if (!artists) return null;

  return (
    <div className="cardd">
      <div className="card-headingg">
        <h1>Top Artists</h1>
      </div>
      <div className="card-contentt">
        <ol>
          {artists.slice(0, 5).map(artist => (
            <li key={artist.name}>{artist.name}</li>
          ))}
        </ol>
      </div>
    </div>
  );
};

export default ImgArtists;
